<aix-notification
    [data-testing]="config.refId!"
    [status]="config.status || 'warning'"
    [isOpen]="true"
    [canClose]="config.isClosable || false"
>
    <span [innerHTML]="(valueToRender$ | async)! | aixSanitize"></span>
</aix-notification>
